export default __webpack_public_path__ + "static/media/kcal.4328a842.svg";